import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "user-container",
  class: "grid-x align-stretch"
}
const _hoisted_2 = { class: "cell auto grid-x align-middle user-name" }
const _hoisted_3 = { class: "cell auto" }
const _hoisted_4 = {
  key: 0,
  class: "menu"
}
const _hoisted_5 = { class: "cell auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["gird-y align-middle auto", { 'cursor-pointer': _ctx.isAdminOfOrg }]),
          id: "topbar-user-name"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "cell bi bi-person-fill user-icon shrink" }, null, -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.user.profile.email), 1)
          ]),
          (_ctx.isAdminOfOrg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, { to: "/organizations" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('messages.navbar.organization')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "topbar-user-button",
      class: "cell shrink grid-x align-middle",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loginButton && _ctx.loginButton(...args)))
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["cell bi user-icon shrink", { 'bi-chevron-left': _ctx.user.isAuthenticated, 'bi-chevron-right': !_ctx.user.isAuthenticated }])
      }, null, 2),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user.isAuthenticated ? 'Logout' : 'Login'), 1)
    ])
  ]))
}